export const calif_pesticides = [
  "Aldicarb",
  "Carbofuran",
  "Chlordane",
  "Chlorfenapyr",
  "Chlorpyrifos",
  "Coumaphos",
  "Daminozide",
  "Dichlorvos",
  "Dimethoate",
  "Ethoprophos",
  "Etofenprox",
  "Fenoxycarb",
  "Fipronil",
  "Imazalil",
  "Methiocarb",
  "Mevinphos",
  "Paclobutrazol",
  "Parathion Methyl",
  "Propoxur",
  "Spiroxamine",
  "Thiacloprid",
  "Abamectin",
  "Acephate",
  "Acequinocyl",
  "Acetamiprid",
  "Azoxystrobin",
  "Bifenazate",
  "Bifenthrin",
  "Boscalid",
  "Carbaryl",
  "Captan",
  "Chlorantraniliprole",
  "Clofentezine",
  "Cyfluthrin",
  "Cypermethrin",
  "Diazinon",
  "Dimethomorph",
  "Etoxazole",
  "Fenhexamid",
  "Fenpyroximate",
  "Flonicamid",
  "Fludioxonil",
  "Hexythiazox",
  "Imidacloprid",
  "Kresoxim Methyl",
  "Malathion",
  "Metalaxyl",
  "Methomyl",
  "Myclobutanil",
  "Naled",
  "Oxamyl",
  "Pentachloronitrobenzene",
  "Permethrin",
  "Phosmet",
  "Piperonyl Butoxide",
  "Prallethrin",
  "Propiconazole",
  "Pyrethrins",
  "Pyridaben",
  "Spinetoram",
  "Spinosad",
  "Spiromesifen",
  "Spirotetramat",
  "Tebuconazole",
  "Thiamethoxam",
  "Trifloxystrobin"
];